import React from "react";
import Navbar from "../../Shared/NavBar/Navbar";
import ProjectsMainContent from "./Components/ProjectsMainContent";

const Projects = () => {
  return (
    <div className=" main-wrapper">
      <Navbar />
      <ProjectsMainContent />
    </div>
  );
};

export default Projects;
